import validate from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/node_modules/nuxt/dist/pages/runtime/validate.js";
import page_45global from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/middleware/page.global.ts";
import redirect_45global from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/middleware/redirect.global.ts";
import manifest_45route_45rule from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  page_45global,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "recall-success": () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/middleware/recall-success.ts")
}